import * as React from 'react';
import Descriptions from 'antd/lib/descriptions';
import Text from 'antd/lib/typography/Text';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { selectRelease } from '../../selectors/selectors';
import { GRID_CARD_MIN_WIDTH, GRID_GAP, GRID_MIN_WIDTH } from '../../constants';
import SectionHeader from './SectionHeader';
import { CustomMetadataEntry } from '../../types';
interface CustomMetadataSectionProps {
    releaseId: string;
}

const METADATA_LABEL_WIDTH = 140;

const renderMetadataValue = (value: unknown): React.ReactNode => {
    if (typeof value === 'string') {
        return <Text style={{ wordBreak: 'break-word' }}>{value}</Text>;
    }
    // Pretty-print objects/arrays so nested JSON is readable.
    return (
        <Text style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'monospace' }}>
            {JSON.stringify(value, null, 2)}
        </Text>
    );
};

const CustomMetadataSection: React.FC<CustomMetadataSectionProps> = ({ releaseId }) => {
    const customMetadata: Record<string, CustomMetadataEntry> = useSelector(
        (state: RootState) => selectRelease(state, releaseId).customMetadata,
    );

    const entries = customMetadata ? Object.entries(customMetadata) : [];
    if (entries.length === 0) {
        return null;
    }

    return (
        <div>
            <SectionHeader header="Custom metadata" relatedIntegrations={[]} />
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(auto-fill, minmax(${GRID_CARD_MIN_WIDTH}px, ${GRID_MIN_WIDTH}px))`,
                    gap: GRID_GAP,
                }}
            >
                {entries.map(([key, entry]) => (
                    <Descriptions
                        key={key}
                        column={1}
                        bordered
                        size="small"
                        labelStyle={{ width: METADATA_LABEL_WIDTH, wordBreak: 'break-word' }}
                    >
                        <Descriptions.Item label={entry.title || key}>
                            {renderMetadataValue(entry.value)}
                        </Descriptions.Item>
                    </Descriptions>
                ))}
            </div>
        </div>
    );
};

export default CustomMetadataSection;
